import {ICustomizationTemplate, ITemplateData} from '@/utils/types/organization-communication.interface';
import {StoreType} from '..';

export const getEmailCustomizationTemplateSelector = (state: StoreType): ICustomizationTemplate | null =>
	state.organizationCommunicationStore.communicationTemplate;

export const organizationCommunicationLoaderSelector = (state: StoreType): boolean =>
	state.organizationCommunicationStore.isLoading;

export const getEmailTemplatesSelector = (state: StoreType): ITemplateData[] | [] =>
	state.organizationCommunicationStore.templates;
